export default "__VITE_ASSET__xThWYi$o__"